import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../sec_breadcrumb/component';
import Link from '../base_link/component';
import { ProductImage } from 'audamatic-ui';
import { THEME_COLORS } from '@config';
import { Row, Col } from '../util_grid/grid';
import { Product } from '@utils/product';
import { t } from '@utils/i18n';
import './styles/styles.scss';

class CategoryHeader extends Component {
  get store() {
    return this.props.store || {};
  }
  get homeLink() {
    return { name: t('common.home.link'), url: '/' };
  }

  get currentLink() {
    return { name: this.skyline.title, url: window.location.href };
  }

  get breadcrumbs() {
    return this.props.components.find(component => component['component-type'] === 'breadcrumb') ||
    { items: [this.homeLink, this.currentLink] };
  }

  get skyline() {
    return this.props.components.find(component => component['component-type'] === 'bookskyline') || {};
  }

  get title() {
    const { items = [] } = this.breadcrumbs;
    return this.skyline.title || (items.length >= 2 && items[items.length - 1].name);
  }

  get backgroundColor() {
    const defaultHeaderBackground = THEME_COLORS.defaultCatHeaderBGColor; // TODO: deprecate this component so we don't need these kind of exceptions
    const { colorCode  = defaultHeaderBackground, productSelection } = this.skyline;

    return productSelection ? defaultHeaderBackground : colorCode;
  }

  get products() {
    const products = [];
    this.skyline.productSelection.map((sku) => {
      const storedProduct = this.props.store.storedProducts()[sku] || '';
      if (!!storedProduct) {
        return  products.push(storedProduct);
      }
      return false;
    });
    return (this.props.products || products || []).slice(0, 4);
  }

  get bookList() {
    const show  = this.skyline.productSelection && !!this.skyline.productSelection.length;
    if (show) {
      return this.products.map((product, i) => {
        const _product = new Product(product);
        return (
          <Link href={_product.url} className={`item ${i === 0 ? 'hidden-sm' : ''}`} key={i}>
            <ProductImage product={_product} maxHeight={149} />
          </Link>
        );
      });
    }
    return null;
  }

  render() {
    return (
      <div className="category-header" style={{ backgroundColor: this.backgroundColor }}>
        <div className="container">
          <Row className="equal-row">
            <Col sm={6}>
              <div className="centered-content">
                <Breadcrumb items={this.breadcrumbs.items} removable={this.breadcrumbs.removable} />
                <h1>{this.title}</h1>
              </div>
            </Col>
            <Col sm={6} className="right-col hidden-xs">
              <div className="book-row">
                {!!this.skyline.bgImage && (
                  <div className="image-wrapper">
                    <img src={this.skyline.bgImage} alt={this.title} />
                  </div>
                )}
                <div className={`book-list ${!this.booklist ? 'empty' : ''}`}>{this.bookList}</div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
CategoryHeader.propTypes = {
  components: PropTypes.array,
  products: PropTypes.array,
  store: PropTypes.object,
};
export default CategoryHeader;
